"use client";

import SwiperComponent from "@/components/ui/swiper-component";
import AcademyCard from "@/components/SellerAcademy/_card";


const LatestSlider = ({ blogs = [], storage_prefix_url }) => {

    if (!blogs?.length) return null;

    return (
        <section className="lg:hidden">

            <p className="mb-3 text-base font-bold text-jmt-main">
                جدیدترین مطالب سلر آکادمی
            </p>

            <SwiperComponent
                slides_shadow_space
                slides={blogs.map((blog) => (
                    <AcademyCard
                        key={blog?.id || blog?.seo?.full_url}
                        blog={blog}
                        storage_prefix_url={storage_prefix_url}
                    />
                ))}
                breakpoints={{
                    480: { slidesPerView: 2.2, spaceBetween: 12 },
                    768: { slidesPerView: 3, spaceBetween: 16 },
                }}
                slidesPerView={1.5}
                spaceBetween={12}
                grabCursor
                navPosition="sides"
                hideNavOnMobile
            />
        </section>
    );
};

export default LatestSlider;
